import { AnalyticsPayloads } from './types'

export const TRACK_EVENT = 'ANALYTICS/TRACTRACK_EVENT'
export const INIT = 'ANALYTICS/INIT'

export type AnalyticsAction = TrackEventAction | InitAction

export type InitAction = {
  type: typeof INIT
}
export const init = (): InitAction => ({
  type: INIT
})

export type TrackEventAction = {
  payload: AnalyticsPayloads
  type: typeof TRACK_EVENT
}
export const trackEvent = (payload: AnalyticsPayloads): TrackEventAction => ({
  payload,
  type: TRACK_EVENT
})
